import React from 'react';
import { SmallColors } from '../Colors';

export const ProductColors = ({ colors }) => <SmallColors colors={colors} />;
